import React from "react";
import "./PlacementSupport.css";

const PlacementSupport = () => {
  return (
    <section className="ps-section">
      <div className="ps-container">
        <h2 className="ps-title">Placement & Career Support</h2>
        <p className="ps-subtitle">
          From training to job offer — we guide you at every step.
        </p>

        {/* Timeline */}
        <div className="ps-timeline">
          {["Resume", "Mock", "Referrals", "Interviews", "Offer"].map(
            (item, i) => (
              <div className="ps-step" key={i}>
                <div className="ps-circle">{i + 1}</div>
                <p>{item}</p>
              </div>
            ),
          )}
        </div>

        {/* Cards */}
        <div className="ps-cards">
          <div className="ps-card">
            <h3>Resume Preparation</h3>
            <p>ATS-friendly resume building support.</p>
          </div>

          <div className="ps-card">
            <h3>Mock Interviews</h3>
            <p>Practice with real-time interview scenarios.</p>
          </div>

          <div className="ps-card">
            <h3>Interview Guidance</h3>
            <p>Technical & HR preparation.</p>
          </div>

          <div className="ps-card">
            <h3>Job Referrals</h3>
            <p>Connect with hiring companies.</p>
          </div>

          <div className="ps-card">
            <h3>Placement Support</h3>
            <p>Continuous assistance till placement.</p>
          </div>

          <div className="ps-card">
            <h3>Career Growth</h3>
            <p>Mentorship beyond placement.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PlacementSupport;
